import { ca } from '@cian/analytics';
import { IProduct } from 'shared/map-search/types/analytics';
export function trackModalOpen(label?: string, product?: IProduct) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label,
    products: product ? [product] : [],
    page: { listingType: 'map', pageType: 'Listing' },
  });
}
